/** Auto-inserts dashes as the user types a 10-digit US phone number —
 * "2142932809" becomes "214-293-2809" progressively as each digit lands,
 * not just once all 10 are in. Strips anything already typed that isn't a
 * digit first, so pasting an already-formatted number, or backspacing
 * over a dash, both just work without fighting the user. Caps at 10
 * digits — this app has no international/extension phone fields. */
export function formatPhoneAsTyped(raw: string): string {
  const digits = raw.replace(/\D/g, "").slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
}
